import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import { CardProdutos } from "./components/card-produtos";
import { useCargasProdutosStyles } from "./cargas-produtos-styles";
import { DialogSaurus } from "../../dialog/dialog-saurus/dialog-saurus";
import { useToastSaurus } from "../../../../service/app/use-cases";
import { CargasProdutosModel } from "../../../../model/api/cargas-produto/cargas-produtos-model";
import { useCallback, useEffect, useState } from "react";
import { useGetCargasProdutosById } from "../../../../data/api/gestao/cargas-produtos/get-cargas-produtos-by-id";
import { useThemeQueries } from "../../../../theme";

interface NovaCredencialProps {
  sincronizacaoId: string
  cargasId: string
  lojaId: string
  fecharModal: () => void
  aberto: boolean
}

export const CargasProdutos = ({ sincronizacaoId, lojaId, cargasId, fecharModal, aberto }: NovaCredencialProps) => {
  const classes = useCargasProdutosStyles();
  const { showToast } = useToastSaurus();
  const { getCargasProdutosById, carregando } = useGetCargasProdutosById()
  const { isMobile } = useThemeQueries();
  const [produtos, setProdutos] = useState<CargasProdutosModel[]>([])

  const search = useCallback(
    async () => {
      try {
        const res = await getCargasProdutosById(lojaId, sincronizacaoId, cargasId);
        if (res.erro) throw res.erro;
        const resultado = res.resultado?.data;
        setProdutos(resultado);
      } catch (e: any) {
        showToast("error", e.message);
      }
    },
    [cargasId, getCargasProdutosById, lojaId, showToast, sincronizacaoId]
  );

  useEffect(() => {
    if (aberto) {
      search()
    }
  }, [aberto, search]);


  return (
    <>
      <DialogSaurus
        isButtonTitleClose
        handleClickClose={fecharModal}
        carregando={carregando}
        aberto={aberto}
        titulo="Carga de Produtos"
        tamanho='lg'
        fullScreen={isMobile}
      >
        <TableContainer component={Paper} className={classes.tableContainerHeaderFixed} style={{ maxHeight: isMobile ? '100%' : 500 }}>
          <Table stickyHeader className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align='center'>
                  <Typography>Código</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Descrição</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Categoria</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Valor</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>NCM</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Marca</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Medida</Typography>
                </TableCell>
                <TableCell align='center'>
                  <Typography>Situação</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <CardProdutos
                carregando={carregando}
                produtos={produtos}
                cargasId={cargasId}
                lojaId={lojaId}
                sincronizacaoId={sincronizacaoId}
              />
            </TableBody>
          </Table>
        </TableContainer>


      </DialogSaurus>
    </>
  )
}

